import ContentLoader from 'react-content-loader';

const MIN_WIDTH = 400;
const HEIGHT = 64;

const AddressSkeleton = ({ height = HEIGHT, ...props }) => {
	return (
		<ContentLoader
			speed={2}
			width='100%'
			height={height}
			viewBox={`0 0 ${MIN_WIDTH} ${HEIGHT}`}
			backgroundColor='#f3f3f3'
			foregroundColor='#ecebeb'
			preserveAspectRatio='xMinYMin meet'
			{...props}
		>
			<rect x='16' y='14' rx='6' width='120' height='16' />
			<rect x='16' y='40' rx='4' width='80' height='8' />
		</ContentLoader>
	);
};
export default AddressSkeleton;
